import { cn } from '@/lib/utils';
import { LedNumber } from './LedNumber';

type LeaderboardRowProps = {
  rank: number;
  name: string;
  score: number;
  isMe?: boolean;
  paying?: boolean;
  pending?: boolean;
};

const rankBadge = (rank: number) => {
  if (rank === 1) return 'bg-gold-gradient text-cabinet-flame-ember';
  if (rank === 2) return 'bg-chrome-bevel text-cabinet-purple-ink';
  if (rank === 3) return 'bg-flame-gradient text-cabinet-cream';
  return 'bg-cabinet-purple text-cabinet-cream/80';
};

export function LeaderboardRow({
  rank,
  name,
  score,
  isMe,
  paying,
  pending,
}: LeaderboardRowProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-xl px-3 py-2.5 ring-1 transition',
        isMe
          ? 'ring-cabinet-gold bg-cabinet-purple-deep'
          : 'ring-cabinet-cream/10 bg-cabinet-purple-ink/60',
      )}
    >
      <div
        className={cn(
          'flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-display text-lg ring-2 ring-black/30',
          rankBadge(rank),
        )}
      >
        {rank}
      </div>

      <div className="min-w-0 flex-1">
        <p className="truncate font-display tracking-wide text-cabinet-cream text-base">
          {name}
          {isMe ? <span className="ml-2 text-xs text-cabinet-gold-bright">(you)</span> : null}
        </p>
        <div className="mt-0.5 flex items-center gap-2 text-[10px] uppercase tracking-widest text-cabinet-cream/50">
          {paying ? <span className="text-cabinet-gold-bright">Paying place</span> : <span>—</span>}
          {pending ? <span className="text-cabinet-flame-orange">Pending verify</span> : null}
        </div>
      </div>

      <LedNumber value={score} digits={4} size="sm" />
    </div>
  );
}
